import { usePartnerId } from 'utils/routing/params.hooks'
import { usePartnerSandboxOrder } from 'domains/connect/api/sandbox-order/fetchPartnerSandboxOrder.hooks'
import { useErrorNotification } from 'domains/connect/components/utils/notifications.hooks'

export const useSandboxOrder = (orderId: string) => {
  const partnerId = usePartnerId()
  const { sandboxOrder, error, loading } = usePartnerSandboxOrder(partnerId, orderId)
  useErrorNotification(error, 'connect.fulfillmentSimulator.loadOrder.error')
  return { sandboxOrder, error, loading }
}
